import type { Message } from '@/common/db-typebox/chat.typebox';
import Dexie, { type Table } from 'dexie';

export class ChatDatabase extends Dexie {
  messages!: Table<Message>;

  constructor() {
    super('ChatDatabase');
    this.version(1).stores({
      messages:
        'id, user_id, conversation_id, parent_id, role, content, params, created_at, updated_at',
    });
  }
}

export const db = new ChatDatabase();
